import { DisciplineResults } from '../../Components/DisciplineResults';

export const NRAActionPistolResults = () => {
  return (
    <DisciplineResults 
      discipline="NRA_ACTION_PISTOL" 
      disciplineName="NRA Action Pistol"
    />
  );
};
